export default __webpack_public_path__ + "static/char-s-45-zh-Hant-45f7a99f187fb7f59da2a390078713bd.webp";